export default __webpack_public_path__ + "static/media/post2.1713c310.jpg";